export default "__VITE_ASSET__BEg2XX07__"